<template>
  <div>
    <BSelect
      :options="options"
      :filterable="true"
      :clearable="true"
      :disabled="disabled"
      :infos="infos"
      :initLevel="level"
      :filter="filter"
      @contents="contents"
      v-model="datas"
      :placeholder="placeholder"
      @change="change"
    >

    </BSelect>
  </div>
</template>
<script>
import Vue from 'vue'
import BSelect from '@/components/ganttRegion-select'
let arr = []
export default {
  name: 'addressSelect',
  components: {
    BSelect
  },
  data () {
    let _this = this
    return {
      options: arr,
      datas: _this.value,
      infos: _this.regionsSelect,
      filter: Vue.filter('coverRegion'),
      contentData: []
    }
  },
  watch: {
    datas (newVal) {
      this.$emit('input', newVal)
    },
    contentData (newVal) {
      this.$emit('contents', this.contentData)
    },
    value (newVal) {
      this.datas = newVal
    }
  },
  methods: {
    contents (val) {
      this.contentData = val
    },
    change (val) {
      this.$emit('change', val)
    }
  },
  props: {
    level: {
      type: Number,
      default: 2
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array
    },
    placeholder: {
      type: String,
      default: '请选择地址'
    }
  }
}
</script>
